module.exports = __webpack_public_path__ + "static/robesnmore-left-411d88369122b0c72578923c36e86290.png";